




































































































































import Vue from "vue";
import { Component, Prop, Inject, Watch } from "vue-property-decorator";
import Selector from "../../shared/Selector.vue";
import Accordion from "../../shared/Accordion.vue";
import { ContactService } from "../../../services/ContactService";
import { AddressDTO } from "../../../model/data.model";
import {
  AddressListItem,
  IPagination,
  SearchParams
} from "../../../model/component.model";
import Pagination from "../../shared/Pagination.vue";

@Component({
  components: {
    MbeSelector: Selector,
    MbeAccordion: Accordion,
    Pagination: Pagination
  }
})
export default class AddressesList extends Vue {
  @Inject() contactService: ContactService;
  addresses: AddressListItem[] = [];
  allAddressesSelected = false;

  searchParams: SearchParams = {
    search: "",
    orderField: "",
    orderDirection: "asc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };

  created() {
    this.addresses = [];
    this.search();
  }

  @Watch("searchParams.search")
  search() {
    // Ensure that selectAll radio checkbox is deselected
    this.selectAll(false);

    this.addresses = [];
    this.contactService.getAddresses(this.searchParams).then((res: any) => {
      this.pagination.totalElements = res.searchParams.totalElements;
      this.searchParams.totalElements = res.searchParams.totalElements;
      this.searchParams.totalPages = res.searchParams.totalPages;
      this.searchParams.numberOfElements = res.searchParams.numberOfElements;
      this.searchParams.page = res.searchParams.page;
      this.searchParams.pageSize = res.searchParams.pageSize;
      res.addresses.forEach((item: AddressDTO) => {
        const o: AddressListItem = { ...(item as AddressListItem) };
        o.selected = false;
        this.addresses.push(o);
      });
    });
  }

  @Watch("searchParams.orderField") changeSortField() {
    this.search();
  }
  @Watch("searchParams.orderDirection") changeSortDirection() {
    this.search();
  }

  sortTable(field: string, direction: string) {
    this.searchParams.orderField = field;
    this.searchParams.orderDirection = direction;
  }

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.search();
  }

  selectItem(item: AddressListItem) {
    item.selected = !item.selected;
  }

  selectAll(value: boolean) {
    this.allAddressesSelected = value;
    this.addresses.forEach((address: AddressListItem) => {
      address.selected = value;
    });
  }

  addressesSelected() {
    return this.addresses.filter(
      (address: AddressListItem) => address.selected
    );
  }

  moveToDetail(contactId: string, addressId: string) {
    this.$router.push({
      name: "ContactAddressDetails",
      params: { id: contactId, address: addressId }
    });
  }
}
